(function(angular){
	'use strict';
	
	angular
		.module('updateSSNModule')
		.controller('updateSSNController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			UpdateSSNFunction
		]);
	
	function UpdateSSNFunction(
		$timeout,
		globalConfig,
		urlFactory
	){
		var updateSSN = this;

		function displayServerSideError() {
			var duplicateSSN = {
				ssn: updateSSN.errorMessage
			};

			urlFactory.handleServerValidation(updateSSN.updateSsnForm, urlFactory.spoofApiError(duplicateSSN));
		}

		updateSSN.$onInit = function() {
			angular.extend(updateSSN, globalConfig);
			if(updateSSN.errorMessage) {
				$timeout(displayServerSideError, 100);
			}
		};
	}
})(window.angular);